import { Mui } from '@onedesign/ui';
import { ThemeMode } from 'theme/types';
import { Button, Typography } from '@mui/material';

const { Box, styled } = Mui;

export const StyledVerificationCodeFormMain = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  gap: 16,
  flexGrow: 1,
  padding: '28px 70px 108px 70px',
  backgroundColor:
    theme.palette.mode === ThemeMode.Dark
      ? theme.palette.grey[800]
      : theme.palette.grey[100],
  borderRadius: '0px 20px 20px 0px',
  '& > h2': {
    alignSelf: 'center',
    color:
      theme.palette.mode === ThemeMode.Dark
        ? theme.palette.grey[100]
        : theme.palette.grey[700],
    margin: '12px 0',
    fontWeight: 700,
  },
  '& > div, & > button': {
    width: '100%',
  },
  '@media(max-width: 1024px)': {
    borderRadius: '0 0 20px 20px',
    padding: '24px',
    position: 'initial',
  },
}));

export const StyledBackButton = styled(Button)(({ theme }) => ({
  color: theme.palette.grey[600],
  width: 'auto!important',
  alignSelf: 'start',
  padding: 0,
  '&:hover': {
    background: 'transparent',
  },
  '@media(max-width: 1024px)': {
    position: 'absolute',
    top: '20px',
  },
}));

export const StyledDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
}));

export const StyledErrorHelperText = styled(Mui.FormHelperText)(
  ({ theme }) => ({
    color: theme.palette.error.main,
    marginTop: '-8px',
  }),
);
